import { Dispatch } from 'react';

import { GET_NOTIFIED_GAUGES, IGetNotifiedGaugesAction } from '../types';
import { getGaugesNotificationData, MapGaugesNotifications } from '../../../../services/GaugesNotificationService';
import { ActiveProduct } from '../../../../models/ActiveProduct';

export function getGaugesNotifications(
    activeProducts: ActiveProduct[]
): (dispatch: Dispatch<IGetNotifiedGaugesAction>) => void {
    return (dispatch: Dispatch<IGetNotifiedGaugesAction>): void => {
        const notifiedProducts = getGaugesNotificationData(activeProducts);

        dispatch(receiveGaugesNotifications(notifiedProducts));
    };
}

const receiveGaugesNotifications = (notifiedProducts: MapGaugesNotifications): IGetNotifiedGaugesAction => {
    return {
        type: GET_NOTIFIED_GAUGES,
        payload: notifiedProducts,
    };
};
